import { render, staticRenderFns } from "./SearchIndex.vue?vue&type=template&id=153d8156&scoped=true"
import script from "./SearchIndex.vue?vue&type=script&lang=js"
export * from "./SearchIndex.vue?vue&type=script&lang=js"
import style0 from "./SearchIndex.vue?vue&type=style&index=0&id=153d8156&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153d8156",
  null
  
)

export default component.exports